import { useState } from 'react'
import Card from '../Components/Common/Card'
import { InvoiceComparison } from '../Components/Invoice/InvoiceComparison';
import InventoryBuild from '../Components/Inventory/InventoryBuild';
import InventoryComparison from '../Components/Inventory/InventoryComparison';
import "./Styles/FileAutomation.css";
import { useNavigate } from 'react-router-dom';
const FileAutomation = () => {
    const [ActiveOption, setActivedOption] = useState<string | null>(null);
    const navigate = useNavigate();

    const handleSelectOption = (e: React.ChangeEvent<HTMLInputElement>) => {
        setActivedOption(e.currentTarget.value);
    }

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if(ActiveOption) {
            navigate(ActiveOption)
        }
    }
    return (
        <div className='fileautomation-wrapper'>
            <Card title='Automações' options={{}}>
                <form className='select-one' onSubmit={handleSubmit}>
                    <label htmlFor="invoiceComparison">
                        <input type="radio" name="automationOption" id="invoiceComparison" value="invoicecomparison" onChange={handleSelectOption}/>
                        Confronto de Fatura
                    </label>
                    <label htmlFor="inventoryComparison">
                        <input type="radio" name="automationOption" id="inventoryComparison" value="inventorycomparison" onChange={handleSelectOption}/>
                        Confronto de Inventario
                    </label>
                    <label htmlFor="stockComparison">
                        <input type="radio" name="automationOption" id="stockComparison" value="stockcomparison" onChange={handleSelectOption}/>
                        Confronto de Estoque
                    </label>
                    <label htmlFor="inventoryBuild">
                        <input type="radio" name="automationOption" id="inventoryBuild" value="inventorybuild" onChange={handleSelectOption}/>
                        Atualizar Inventario
                    </label>
                    <button type='submit' className='btn-primary'>Avançar</button>
                </form>
            </Card>
    </div>
    )
}

export default FileAutomation